<script setup>
import { computed } from 'vue';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  empty: {
    type: Boolean,
    default: false,
  },
  query: {
    type: String,
    default: '',
  },
  showTitle: {
    type: Boolean,
    default: true,
  },
  isFetching: {
    type: Boolean,
    default: false,
  },
});

const titleCase = computed(() => props.title.toLowerCase());
</script>

<template>
  <section class="result-section">
    <div v-if="showTitle" class="result-section__title">
      <span class="result-section__dot" />
      <h3>{{ title }}</h3>
    </div>

    <div class="result-section__body">
      <slot />
    </div>

    <woot-loading-state
      v-if="isFetching"
      :message="empty ? $t('SEARCH.SEARCHING_DATA') : $t('SEARCH.LOADING_DATA')"
    />

    <div v-if="empty && !isFetching" class="result-section__empty">
      <span class="i-lucide-info size-4" />
      <p>{{ $t('SEARCH.EMPTY_STATE', { item: titleCase, query }) }}</p>
    </div>
  </section>
</template>

<style scoped>
.result-section {
  margin: 0 0 16px;
  overflow: hidden;
  border: 1px solid var(--wlab-border-light, var(--n-weak));
  border-radius: 16px;
  background: var(--wlab-bg-card, var(--n-solid-2));
}

.result-section__title {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--wlab-border-light, var(--n-weak));
}

.result-section__dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: var(--wlab-accent, #6366f1);
}

.result-section__title h3 {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--wlab-text-muted, var(--n-slate-11));
}

.result-section__body {
  padding: 6px;
}

.result-section__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 8px;
  padding: 20px 12px;
  border-radius: 12px;
  background: color-mix(
    in srgb,
    var(--wlab-text-primary, #fff) 4%,
    transparent
  );
  color: var(--wlab-text-muted, var(--n-slate-11));
}

.result-section__empty p {
  margin: 0;
  font-size: 13px;
}
</style>
